/**
 * CAUTION!!!! If you are using this, rethink it.  This should probably ONLY be used in Forms and prompt user task, and
 * only because we have to absolutely position the control to match the control in Form Designer and no retraining for
 * prompt user task. ListPromptInput supports all 4 combinations of editable and allowMultipleValues, and should nearly
 * ALWAYS be used instead of this.
 *
 * Created by rjulius on 2/18/16.
 */
import PromptInput from "common/widgets/PromptList/PromptInput";
import DFListView from "app/widgets/ListView/DFListView";
import util from "common/helper/ObjectUtil";
import locale from "common/managers/locale";
const ListViewPromptInput = PromptInput.extend({
    options: {
        name: "ListViewPromptInput",
        template: "<ul></ul>"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        this.widget = this._render();
        this.widget.bind("change", this.handleChange);
        // set class needed for applying styles to set width / height / labelPosition correctly,
        // based on control type
        if (this.options.model.width && this.options.model.height) {
            this.element.parent().addClass("listboxControl flexLayout");
        }

        this._updateSize();

        this.refresh();
    },

    canControlAcceptFocusWithNoData: function() {
        return false;
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Render and return the input to a particular input based on its properties.
     * @private
     */
    _render: function() {
        var data = this.getData();
        this.input.one("focus", function() {
            //This is for screen reader purposes.
            //The first time an input is focused, it should focus on the first selected row so that it is read by screen readers
            //After that, the users focus should be maintained.
            var sel = widget.select();
            if (sel.length > 0) {
                widget.current($(sel[0]));
            }
        });
        this.element.addClass("dflistbox");
        var widget = new DFListView(this.input, {
            dataSource: {
                data: data
            },
            template: function(data) {
                var ul = $("<ul>");
                var li = $("<li>").text(data.value);
                li.attr("id", kendo.guid());
                ul.append(li);
                return ul.html();
            },
            navigatable: true,
            selectable: this.options.model.allowMultipleValues ? "multiple" : "single"
        });
        if (data.length === 0) {
            this.input.hide();
            this.element.append($("<span>").text(locale.get("message.options.none")));
        }
        return widget;
    },

    handleChange: function() {
        if (!util.compareArray(this.value(), this.options.model.get("value"))) {
            this.options.model.set("value", this.value());
        }
    },

    /**
     * This will be called whenever the attached model's value field is changed.
     *
     */
    updateWidgetValue: function(value) {
        var me = this;
        if (value && value.length > 0) {
            if(!util.isArray(value)) {
                value = [value];
            }
            var rows = [];
            this.widget.element.find("li").each(function(i, val) {
                if (value.indexOf(me.widget.dataItem(val).value) > -1) {
                    rows.push(val);
                }
            });
            this.widget.select(rows);
        } else {
            this.widget.clearSelection();
        }
    },

    enable: function(val) {
        var enable = val && !this.options.model.disabled;
        if (this.widget && this.widget.enable) {
            this.widget.enable(enable);
            this.input.attr("tabindex", enable ? "0" : "-1");
        }
    },

    /**
     * This function must return the value of the UI component
     */
    value: function() {
        var me = this,
            items = [];
        this.widget.select().each(function(i, val) {
            items.push(me.widget.dataItem(val).value);
        });
        return items.length > 0 ? $.makeArray(items) : undefined;
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 50;
        minSize.height = 50;
        return minSize;
    },

    updateSize: function() {
        PromptInput.fn.updateSize.apply(this, arguments);
        this._updateSize();
    },

    _updateSize: function() {
        if (this.options.width && this.options.height) {
            this.element.parent().css("height", this.options.height + "px");
        }
    }
});
kendo.ui.plugin(ListViewPromptInput);
export default ListViewPromptInput;
